
export default {
  name: '',
  props: ['title', 'backgroundColor'],
  methods: {
    
  }
}
